const rocketFiOracleAbi = [
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "adr",
				"type": "address"
			}
		],
		"name": "authorize",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address payable",
				"name": "adr",
				"type": "address"
			}
		],
		"name": "transferOwnership",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address payable",
				"name": "_rocketFi",
				"type": "address"
			}
		],
		"stateMutability": "nonpayable",
		"type": "constructor"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": false,
				"internalType": "address",
				"name": "owner",
				"type": "address"
			}
		],
		"name": "OwnershipTransferred",
		"type": "event"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "adr",
				"type": "address"
			}
		],
		"name": "unauthorize",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "contract IBurnToEarnOracle",
				"name": "_burnToEarnOracle",
				"type": "address"
			}
		],
		"name": "updateBurnToEarnOracle",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "contract IProtocolDistributionGateway",
				"name": "_protocolGateway",
				"type": "address"
			}
		],
		"name": "updateProtocolGateway",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "contract IReflectionPoolOracle",
				"name": "_reflectionPoolOracle",
				"type": "address"
			}
		],
		"name": "updateReflectionPoolOracle",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "contract IRocketForgeOracle",
				"name": "_rocketForgeOracle",
				"type": "address"
			}
		],
		"name": "updateRocketForgeOracle",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "contract IRocketPlayOracle",
				"name": "_rocketPlayOracle",
				"type": "address"
			}
		],
		"name": "updateRocketPlayOracle",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "burnToEarnOracle",
		"outputs": [
			{
				"internalType": "contract IBurnToEarnOracle",
				"name": "",
				"type": "address"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "holder",
				"type": "address"
			}
		],
		"name": "getRocketData",
		"outputs": [
			{
				"components": [
					{
						"components": [
							{
								"internalType": "uint256",
								"name": "rocketFiBalance",
								"type": "uint256"
							},
							{
								"internalType": "uint256",
								"name": "rocketFiDestroyedByBurn",
								"type": "uint256"
							},
							{
								"internalType": "uint256",
								"name": "rocketFiInDeadWallet",
								"type": "uint256"
							},
							{
								"internalType": "uint256",
								"name": "rocketFiTotalSupply",
								"type": "uint256"
							},
							{
								"internalType": "uint256",
								"name": "rocketFiCirculatingSupply",
								"type": "uint256"
							},
							{
								"internalType": "uint256",
								"name": "rocketFiLiquidityBacking",
								"type": "uint256"
							},
							{
								"internalType": "uint256",
								"name": "rocketFiBuyFee",
								"type": "uint256"
							},
							{
								"internalType": "uint256",
								"name": "rocketFiSellFee",
								"type": "uint256"
							},
							{
								"internalType": "uint256",
								"name": "rocketFiTransferFee",
								"type": "uint256"
							}
						],
						"internalType": "struct RocketFiOracleLibrary.TokenData",
						"name": "tokenData",
						"type": "tuple"
					},
					{
						"components": [
							{
								"internalType": "uint256",
								"name": "burnedAmount",
								"type": "uint256"
							},
							{
								"internalType": "uint256",
								"name": "totalCirculatingRocketFuel",
								"type": "uint256"
							},
							{
								"internalType": "uint256",
								"name": "rocketFuelAmount",
								"type": "uint256"
							},
							{
								"internalType": "uint256",
								"name": "unclaimedRocketFi",
								"type": "uint256"
							},
							{
								"internalType": "uint256",
								"name": "totalRocketFiRewarded",
								"type": "uint256"
							},
							{
								"internalType": "uint256",
								"name": "totalBurned",
								"type": "uint256"
							},
							{
								"internalType": "uint256",
								"name": "stakingPoints",
								"type": "uint256"
							},
							{
								"internalType": "uint256",
								"name": "totalSold",
								"type": "uint256"
							},
							{
								"internalType": "uint256",
								"name": "loyaltyBoost",
								"type": "uint256"
							},
							{
								"internalType": "uint256",
								"name": "totalExcluded",
								"type": "uint256"
							},
							{
								"internalType": "uint256",
								"name": "totalRealised",
								"type": "uint256"
							},
							{
								"internalType": "uint256",
								"name": "totalRealisedUndeposited",
								"type": "uint256"
							},
							{
								"internalType": "bool",
								"name": "isExistingBurner",
								"type": "bool"
							},
							{
								"internalType": "bool",
								"name": "isMigrated",
								"type": "bool"
							}
						],
						"internalType": "struct RocketFiOracleLibrary.BurnData",
						"name": "burnData",
						"type": "tuple"
					},
					{
						"components": [
							{
								"internalType": "uint256",
								"name": "smartRewardsTotalShares",
								"type": "uint256"
							},
							{
								"internalType": "uint256",
								"name": "smartRewardsBoostFromRocketFuel",
								"type": "uint256"
							},
							{
								"internalType": "uint256",
								"name": "userShares",
								"type": "uint256"
							},
							{
								"internalType": "uint256",
								"name": "totalSubscriptionWeight",
								"type": "uint256"
							},
							{
								"internalType": "uint256[]",
								"name": "subscriptionPools",
								"type": "uint256[]"
							}
						],
						"internalType": "struct RocketFiOracleLibrary.SmartData",
						"name": "smartData",
						"type": "tuple"
					},
					{
						"components": [
							{
								"internalType": "uint256",
								"name": "yourPoolChanceBurn",
								"type": "uint256"
							},
							{
								"internalType": "uint256",
								"name": "yourPoolChanceBuy",
								"type": "uint256"
							},
							{
								"internalType": "uint256",
								"name": "rocketTokens",
								"type": "uint256"
							},
							{
								"internalType": "uint256",
								"name": "totalBoostPoolEarnings",
								"type": "uint256"
							},
							{
								"internalType": "uint256",
								"name": "availableBoostPoolEarningsToClaim",
								"type": "uint256"
							},
							{
								"internalType": "uint256",
								"name": "claimedPayBoosts",
								"type": "uint256"
							},
							{
								"internalType": "uint256",
								"name": "burnBoostAvailable",
								"type": "uint256"
							},
							{
								"internalType": "uint256",
								"name": "buyBoostAvailable",
								"type": "uint256"
							},
							{
								"internalType": "uint256",
								"name": "payBoostAvailable",
								"type": "uint256"
							},
							{
								"internalType": "uint256",
								"name": "rocketFiRequiredForRollingBurnBoost",
								"type": "uint256"
							},
							{
								"internalType": "uint256",
								"name": "rocketFiRequiredForRollingBuyBoost",
								"type": "uint256"
							},
							{
								"internalType": "uint256",
								"name": "rocketFiRequiredForPayBoost",
								"type": "uint256"
							},
							{
								"internalType": "uint256",
								"name": "lastBurnBoostWonAmount",
								"type": "uint256"
							},
							{
								"internalType": "address",
								"name": "lastBurnBoostWinner",
								"type": "address"
							},
							{
								"internalType": "uint256",
								"name": "lastBurnBoostWinTime",
								"type": "uint256"
							},
							{
								"internalType": "uint256",
								"name": "lastBuyBoostWonAmount",
								"type": "uint256"
							},
							{
								"internalType": "address",
								"name": "lastBuyBoostWinner",
								"type": "address"
							},
							{
								"internalType": "uint256",
								"name": "lastBuyBoostWinTime",
								"type": "uint256"
							},
							{
								"internalType": "uint256",
								"name": "lastPayBoostClaimedAmount",
								"type": "uint256"
							},
							{
								"internalType": "address",
								"name": "lastPayBoostClaimer",
								"type": "address"
							},
							{
								"internalType": "uint256",
								"name": "lastPayBoostClaimTime",
								"type": "uint256"
							},
							{
								"internalType": "bool",
								"name": "inBurnBoostCoolDown",
								"type": "bool"
							},
							{
								"internalType": "bool",
								"name": "inBuyBoostCoolDown",
								"type": "bool"
							},
							{
								"internalType": "bool",
								"name": "inPayBoostCoolDown",
								"type": "bool"
							}
						],
						"internalType": "struct RocketFiOracleLibrary.PlayData",
						"name": "playData",
						"type": "tuple"
					},
					{
						"components": [
							{
								"internalType": "string",
								"name": "referralCode",
								"type": "string"
							},
							{
								"internalType": "uint256",
								"name": "totalReferrals",
								"type": "uint256"
							},
							{
								"internalType": "uint256",
								"name": "totalPurchases",
								"type": "uint256"
							},
							{
								"internalType": "uint256",
								"name": "totalPurchased",
								"type": "uint256"
							},
							{
								"internalType": "address",
								"name": "lastPurchaser",
								"type": "address"
							},
							{
								"internalType": "uint256",
								"name": "rocketFuelEarned",
								"type": "uint256"
							},
							{
								"internalType": "bool",
								"name": "canGenerateReferral",
								"type": "bool"
							}
						],
						"internalType": "struct RocketFiOracleLibrary.ForgeData",
						"name": "forgeData",
						"type": "tuple"
					}
				],
				"internalType": "struct RocketFiOracleLibrary.RocketFiData",
				"name": "_rocketFiData",
				"type": "tuple"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "enum RocketLibrary.TransferType",
				"name": "_transferType",
				"type": "uint8"
			}
		],
		"name": "getTaxFees",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "fee",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "holder",
				"type": "address"
			}
		],
		"name": "getTokenPoolData",
		"outputs": [
			{
				"components": [
					{
						"internalType": "address",
						"name": "_tokenAddress",
						"type": "address"
					},
					{
						"internalType": "string",
						"name": "_name",
						"type": "string"
					},
					{
						"internalType": "string",
						"name": "_symbol",
						"type": "string"
					},
					{
						"internalType": "uint256",
						"name": "_decimals",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "_totalSupply",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "_poolID",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "_shareCount",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "_totalDistributed",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "_bnbPending",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "_balanceOfHolder",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "_amountBalanceWorthAggreggated",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "_unclaimedAmount",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "_claimedAmount",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "_holderPoolShares",
						"type": "uint256"
					},
					{
						"internalType": "address",
						"name": "_reflectionPoolAddress",
						"type": "address"
					}
				],
				"internalType": "struct RocketFiOracleLibrary.PoolData[]",
				"name": "_poolData",
				"type": "tuple[]"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "adr",
				"type": "address"
			}
		],
		"name": "isAuthorized",
		"outputs": [
			{
				"internalType": "bool",
				"name": "",
				"type": "bool"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "account",
				"type": "address"
			}
		],
		"name": "isOwner",
		"outputs": [
			{
				"internalType": "bool",
				"name": "",
				"type": "bool"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "protocolGateway",
		"outputs": [
			{
				"internalType": "contract IProtocolDistributionGateway",
				"name": "",
				"type": "address"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "reflectionPoolOracle",
		"outputs": [
			{
				"internalType": "contract IReflectionPoolOracle",
				"name": "",
				"type": "address"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "rocketForgeOracle",
		"outputs": [
			{
				"internalType": "contract IRocketForgeOracle",
				"name": "",
				"type": "address"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "rocketPlayOracle",
		"outputs": [
			{
				"internalType": "contract IRocketPlayOracle",
				"name": "",
				"type": "address"
			}
		],
		"stateMutability": "view",
		"type": "function"
	}
];
  
  export default rocketFiOracleAbi;